var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "side-menu" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _c("div", { staticClass: "user" }, [
        _c("img", { staticClass: "avatar", attrs: { src: _vm.avatar } }),
        _vm._v(" "),
        _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.name))]),
        _vm._v(" "),
        _c("div", { staticClass: "role" }, [
          _vm._v(
            _vm._s(_vm.subject) +
              _vm._s(_vm.subject && _vm.role ? "/" : "") +
              _vm._s(_vm.role)
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "menu" },
        [
          _c(
            "el-menu",
            {
              staticClass: "side-menu-vertical",
              attrs: {
                "default-active": _vm.menu_index,
                "text-color": "#999999",
                "active-text-color": "#08C060"
              },
              on: { select: _vm.selectMenu, open: _vm.openMenu }
            },
            [
              _c(
                "el-submenu",
                { attrs: { index: "1" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "menu-item",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-pc-examination" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-title" }, [
                        _vm._v("在线考试")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item-group",
                    [
                      _c(
                        "el-menu-item",
                        { staticClass: "sub-item", attrs: { index: "1-2" } },
                        [_vm._v("试卷管理")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        { staticClass: "sub-item", attrs: { index: "1-3" } },
                        [_vm._v("考试记录")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        { staticClass: "sub-item", attrs: { index: "1-1" } },
                        [_vm._v("创建试卷")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-submenu",
                { attrs: { index: "2" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "menu-item",
                      attrs: { slot: "title" },
                      slot: "title"
                    },
                    [
                      _c("i", { staticClass: "iconfont icon-pc-achievements" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "menu-title" }, [
                        _vm._v("成绩管理")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-menu-item-group",
                    [
                      _c(
                        "el-menu-item",
                        { staticClass: "sub-item", attrs: { index: "2-1" } },
                        [_vm._v("成绩管理")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-menu-item",
                        { staticClass: "sub-item", attrs: { index: "2-2" } },
                        [_vm._v("发布成绩")]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "3" } }, [
                _c("div", { staticClass: "menu-item" }, [
                  _c("i", { staticClass: "iconfont icon-pc-post-copy" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("班级发布")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "4" } }, [
                _c("div", { staticClass: "menu-item" }, [
                  _c("i", { staticClass: "iconfont icon-pc-more" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("其他功能")
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("el-menu-item", { attrs: { index: "5" } }, [
                _c("div", { staticClass: "menu-item" }, [
                  _c("i", { staticClass: "iconfont icon-pc-service" }),
                  _vm._v(" "),
                  _c("span", { attrs: { slot: "title" }, slot: "title" }, [
                    _vm._v("在线客服")
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "footer" }, [
        _c(
          "div",
          { staticClass: "logout need-active", on: { click: _vm.logout } },
          [_vm._v("\n        安全退出\n      ")]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: require("@/assets/images/logo.jpg") }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "product-name" }, [_vm._v("AA班级助手")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f4d64aa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f4d64aa","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pc/el-side-menu.vue
// module id = null
// module chunks = 